import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    onPageChange(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageButtons = 5;
    const halfMaxButtons = Math.floor(maxPageButtons / 2);

    let startPage = Math.max(1, currentPage - halfMaxButtons);
    let endPage = Math.min(totalPages, currentPage + halfMaxButtons);

    if (currentPage <= halfMaxButtons) {
      endPage = Math.min(totalPages, maxPageButtons);
    } else if (currentPage + halfMaxButtons >= totalPages) {
      startPage = Math.max(1, totalPages - maxPageButtons + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`mx-1 px-3 py-1 bg-gray-700 rounded text-lg ${currentPage === i ? '!bg-primary-500 text-black' : 'hover:bg-gray-500'}`}
          aria-current={currentPage === i ? 'page' : undefined}
          aria-label={`Page ${i}`}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  return (
    <div className='pagination flex justify-center mt-4 mb-12'>
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className='mx-1 px-3 py-1 text-lg bg-gray-700 rounded disabled:opacity-50 hover:bg-gray-500'
        aria-label='Previous Page'
      >
        &laquo;
      </button>
      {renderPageNumbers()}
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className='mx-1 px-3 py-1 text-lg bg-gray-700 rounded disabled:opacity-50 hover:bg-gray-500'
        aria-label='Next Page'
      >
        &raquo;
      </button>
    </div>
  );
};

export default Pagination;
